export const contactFilterOps = {
    name: {
      inputType: 'text',
      placeholder: 'Search by Name',
      title:'Name'
    },
    email: {
      inputType: 'text',
      placeholder: 'Search by Email',
      title:'Email'
    },
    lessee_id: {
      inputType: 'dropdown',
      placeholder: 'Search by Lessee name',
      title:'Lessee',
      labelKey:'name',
      valueKey:'id',
      options:[]
    },
    title: {
      inputType: 'dropdown',
      placeholder: 'Search by Designation',
      title:'Designation',
      labelKey:'name',
      valueKey:'name',
      options:[]
    }
}